import { render, staticRenderFns } from "./Screen3.vue?vue&type=template&id=b8dccfc6&lang=html&"
import script from "./Screen3.vue?vue&type=script&lang=js&"
export * from "./Screen3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports